import { isValidEmail } from "../helpers";

export function validateForgotPassword(values) {
    let errors = {}

    if (!values.email)
        errors.email = "Email is required"
    else if (!isValidEmail(values.email))
        errors.email = "Email is invalid"

    return errors;
}